import React from 'react';
import { fromJS } from 'immutable';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';

import Comments from '../../Comments';
import PaymentArtisan from '../../Payment/PaymentArtisan';
import Supplies from '../../Supplies';

const PaymentView = ({
  data,
  artisan,
  save,
  loading,
  visible,
  statusRemuneration,
  user,
  users,
  onReject,
  onValidate,
  finishLoading,
  sendPayement,
  setRem,
  setInter,
  setComments,
}) => (
  <React.Fragment>
    <DialogContent>
      <Grid container spacing={1}>
        <Grid item xs={12} style={{ marginBottom: '30px' }}>
          <PaymentArtisan
            finishLoading={finishLoading}
            data={data}
            artisan={artisan}
            save={save}
            statusRemuneration={statusRemuneration}
            sendPayement={sendPayement}
            setRem={setRem}
            callback={onReject}
          />
        </Grid>
        <Grid item xs={12}>
          <Comments
            users={users}
            user={user}
            userId={user._id}
            id={data.interId || data.id}
            interId={data.interId || data._id}
            comments={fromJS(data.comments)}
            setData={(c, v) => setComments(v)}
          />
        </Grid>
        <Grid item xs={12}>
          <Supplies
            merge={fromJS(data)}
            setData={setInter}
            tva={artisan && artisan.tva}
            value={fromJS(data.supplies)}
            user={user}
          />
        </Grid>
      </Grid>
    </DialogContent>
    <DialogActions
      sx={{
        position: 'sticky',
        bottom: 0,
        backgroundColor: 'background.paper',
        zIndex: 1,
      }}
    >
      <Button
        onClick={onReject}
        color="primary"
        children="Annuler"
      />
      <LoadingButton
        loading={loading}
        disabled={visible}
        onClick={onValidate}
        color="primary"
      >
        Valider
      </LoadingButton>
    </DialogActions>
  </React.Fragment>
);

export default PaymentView;
